export const searchEngines = [
  {
    id: 'Dynamed',
    name: 'Dynamed',
    logoImage: require('@/assets/images/icon_dynamed.png'),
    baseUrl: 'https://www.dynamed.com',
    searchUrl: 'https://www.dynamed.com/results?q=',
    // urlSuffix: '&lang=en',
    urlSuffix: '&lang=fr',
    iFramable: true,
  },
  {
    id: 'Uptodate',
    name: 'Uptodate',
    logoImage: require('@/assets/images/icon_utd.png'),
    baseUrl: 'https://www.uptodate.com/contents/search',
    searchUrl: 'https://www.uptodate.com/contents/search?search=',
    urlSuffix: '',
    iFramable: true,
  },
  {
    id: 'MerckManuals',
    name: 'MerckManuals',
    logoImage: require('@/assets/images/icon_merck.png'),
    baseUrl: 'https://www.msdmanuals.com/fr/professional',
    // searchUrl: 'https://www.merckmanuals.com/professional/SearchResults?query=',
    searchUrl: 'https://www.msdmanuals.com/fr/professional/SearchResults?query=',
    urlSuffix: '',
    iFramable: true,
  },
  {
    id: 'Amboss',
    name: 'Amboss',
    logoImage: require('@/assets/images/icon_amboss.png'),
    baseUrl: 'https://www.amboss.com/us/knowledge',
    searchUrl: 'https://www.amboss.com/us/knowledge/index/?term=',
    urlSuffix: '',
    iFramable: false,
  },
  {
    id: 'Pubmed',
    name: 'Pubmed',
    logoImage: require('@/assets/images/icon_pubmed.png'),
    baseUrl: 'https://pubmed.ncbi.nlm.nih.gov',
    searchUrl: 'https://pubmed.ncbi.nlm.nih.gov/?term=',
    urlSuffix: '',
    iFramable: false,
  },
  {
    id: 'Ordotype',
    name: 'Ordotype',
    logoImage: require('@/assets/images/icon_ordotype.png'),
    baseUrl: 'https://www.ordotype.fr/pathologies',
    searchUrl: 'https://www.ordotype.fr/pathologies',
    urlSuffix: '',
    iFramable: true,
  },
]

export function getSearchEngineLogo(linkUrl) {
  const searchEngine = searchEngines.find(engine => haveSameHostname(engine.baseUrl, linkUrl))
	if (searchEngine) return searchEngine.logoImage
  const medicSearchEngine = medicSearchEngines.find(engine => haveSameHostname(engine.baseUrl, linkUrl))
	if (medicSearchEngine) return medicSearchEngine.logoImage
  return null //searchEngines[0].logoImage
}

function haveSameHostname(url1, url2) {
	try {
			const parsedUrl1 = new URL(url1)
			const parsedUrl2 = new URL(url2)
			return parsedUrl1.hostname === parsedUrl2.hostname
	} catch (error) {
			console.log('Invalid URLs')
			return false
	}
}

export const medicSearchEngines = [
  {
    id: 'Vidal',
    name: 'Vidal',
    logoImage: require('@/assets/images/icon_vidal.png'),
    baseUrl: 'https://www.vidal.fr',
    searchUrl: 'https://www.vidal.fr/recherche/medicaments.html?query=',
    // searchUrl: 'https://www.vidal.fr/recherche.html?query=',
    urlSuffix: '',
    iFramable: false,
  },
  {
    id: 'Compendium.ch',
    name: 'Compendium.ch',
    logoImage: require('@/assets/images/icon_compendium.ch.png'),
    baseUrl: 'https://compendium.ch',
    searchUrl: 'https://compendium.ch/search?q=',
    urlSuffix: '',
    iFramable: true,
  },
  {
    id: 'cbip',
    name: 'cbip',
    logoImage: require('@/assets/images/icon_cbip.jpg'),
    baseUrl: 'https://www.cbip.be/fr/chapters',
    // searchUrl: 'https://www.cbip.be',
    // searchUrl: 'https://www.cbip.be/fr/keywords/',
    searchUrl: 'https://samviewer.digile.be/fr/search?filter=brand-ampp-true&q=',
    urlSuffix: '',
    // urlSuffix: '?type=substance',
    iFramable: false,
  },
  {
    id: 'posos',
    name: 'posos',
    logoImage: require('@/assets/images/icon_posos.png'),
    baseUrl: 'https://app.posos.co/app/results',
    searchUrl: 'https://app.posos.co/app/results/drugs?q=',
    urlSuffix: '',
    iFramable: false,
  },
]

export function getSearchEnginePath(engine, searchTerms) {
  //Return baseURL
  if (!searchTerms || !engine.searchUrl) {
    return engine.baseUrl
  }
  if (['Ordotype'].includes(engine.id)) {
    return engine.baseUrl
  }
  //Create searchUrl
  searchTerms = searchTerms.trim().replaceAll(' ', '+')
  searchTerms = searchTerms.replaceAll('-', '+')
  return engine.searchUrl + searchTerms + engine.urlSuffix
}

// export function getCbipSearchEnginePath(engine, substanceTerms) {
//   if (!substanceTerms) return engine.baseUrl;

//   if (substanceTerms.includes("-")) {
//     let position = substanceTerms.indexOf("-")
//     substanceTerms = substanceTerms.slice(0, position)
//   }
//   substanceTerms = substanceTerms
//     .toLowerCase()
//     .replace("paracetamol", "paracétamol")
//     .replace("acetaminophen", "paracétamol")
//     .replace("codein", "codéin")
//     .replace("ibuprofen", "ibuprofène")
//     .replace("ibuprofene", "ibuprofène")

//   //Create searchUrl
//   substanceTerms = substanceTerms.trim().replaceAll(' ', '+')
//   substanceTerms = substanceTerms.replaceAll('-', '+')
//   return engine.searchUrl + substanceTerms + engine.urlSuffix
// }

export function getDefaultSearchEngine(expr) {
  return (expr?.expressionType === "SubstanceAdministrationPrescription" || expr?.aggressorRoot === "MedicSubstance") ? medicSearchEngines[1] : searchEngines[0]
}
